'use strict';

angular.module('mean.accounts-receivable').factory('Estimates', ['$resource',
  function($resource) {
    return $resource('api/estimates/:estimateId', {
      estimateId: '@_id'
    }, {
        update: {
            method: 'PUT'
        }
    });
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/services/estimates.js